function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  &.inline {\n    display: flex;\n  }\n  &.block {\n    display: block;\n  }\n  .component {\n    margin: 5px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var StyledComponentGroup = styled.div(_templateObject());

var ComponentGroup = function ComponentGroup(_ref) {
  var components = _ref.components,
      variant = _ref.variant,
      containerClass = _ref.containerClass,
      rest = _objectWithoutPropertiesLoose(_ref, ["components", "variant", "containerClass"]);

  return /*#__PURE__*/React.createElement(StyledComponentGroup, _extends({
    className: variant + " " + containerClass
  }, rest), components.map(function (_ref2, index) {
    var Component = _ref2.component,
        styledClass = _ref2.styledClass,
        propsData = _ref2.propsData;
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: "component " + styledClass,
      key: index
    }, propsData));
  }));
};

ComponentGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  components: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.node.isRequired,
    propsData: PropTypes.object,
    styledClass: PropTypes.string
  })),
  variant: PropTypes.string,
  containerClass: PropTypes.string
} : {};
ComponentGroup.defaultProps = {
  variant: 'block',
  theme: defaultTheme,
  containerClass: '',
  styledClass: ''
};
export default ComponentGroup;